// src/hooks/banks/useDeleteAllBanks.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllBanks } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useDeleteAllBanks() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: deleteAllBanksMutation, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllBanks,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم حذف البنوك المحددة بنجاح" : "Selected banks deleted successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في حذف البنوك" : "Failed to delete banks"));
        },
    });

    return { deleteAllBanks: deleteAllBanksMutation, isDeleteAll };
}

export default useDeleteAllBanks;
